;(function () {
  'use strict'

  angular.module('contrast.permissions').constant('ACCESS_EVENTS', {
    ACCESS_RELOAD: 'access:reload'
  })
})()
